import { useEffect, useState } from "react";
import { DEFAULT_CAPABILITY_CARDS, fetchCapabilities } from "@repo/ui/chat";
import type { CapabilityCard, KyInstance } from "@repo/ui/chat";

/**
 * Welcome-screen cards from the agent's `capabilities` bootstrap. Runs once per mount —
 * `App` holds this hook above `AgentProvider`, so a new chat remounts the provider but
 * not the bootstrap, and the registry only changes with an agent deploy.
 *
 * Starts on the default cards so nothing waits on the agent, and keeps them if the bootstrap
 * fails or delivers nothing.
 */
export function useAgentCapabilities(api: KyInstance): CapabilityCard[] {
  const [cards, setCards] = useState<CapabilityCard[]>(DEFAULT_CAPABILITY_CARDS);

  useEffect(() => {
    let cancelled = false;

    fetchCapabilities(api)
      .then((fetched) => {
        if (!cancelled && fetched.length) setCards(fetched);
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, [api]);

  return cards;
}
